// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
//import * as firebaseui from 'firebaseui';
//import { EmailAuthProvider, GoogleAuthProvider } from 'firebaseui/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCIjA_CeGBiYH_zwVv8cLmqHvfUf2pkVuE",
  authDomain: "settersocial.firebaseapp.com",
  projectId: "settersocial",
  storageBucket: "settersocial.firebasestorage.app",
  messagingSenderId: "920353770890",
  appId: "1:920353770890:web:d1471992fe7c6879c5cc73",
  measurementId: "G-SB7Z7F5YY7"
};

//console.log(firebaseui);

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

//const ui = new firebaseui.auth.AuthUI(auth);

// Configure FirebaseUI (customize as needed)
/* ui.start('#firebaseui-auth-container', {
  signInSuccessUrl: '/', // Redirect after successful sign-in
  signInOptions: [
    {
      provider: app.auth.GoogleAuthProvider.PROVIDER_ID,
      clientId:
        "920353770890-6si24p7b12sl5sflejit8et2cgd1n8v6.apps.googleusercontent.com",
    },
    {
      provider: app.auth.EmailAuthProvider.PROVIDER_ID,
    },
  ],
}); */

export { app, analytics, auth, db, storage }